import { render, staticRenderFns } from "./CustomerServiceManage.vue?vue&type=template&id=0f4f6391&scoped=true"
import script from "./CustomerServiceManage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerServiceManage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CustomerServiceManage.vue?vue&type=style&index=0&id=0f4f6391&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4f6391",
  null
  
)

export default component.exports